import { BaseBus } from "./BaseBus";
import { OrderDetailsBus } from "./OrderDetailsBus";
import { CommonFunctions } from "../static/common-functions";

export class OrderReceiveDetailsBus extends BaseBus
{
    CID(): any {
        return this.orderReceiveDetailId;
    }
    constructor(data: OrderReceiveDetailsBus) {
        super(data);
    }
    initialize(data: OrderReceiveDetailsBus) {
        super.initialize(data);
        try {
            this.insertDt = CommonFunctions.getDate(data.insertDt);
            this.updateDt = CommonFunctions.getDate(data.updateDt);
        }
        catch {

        }

    }
    setCommon(userId: any, date: Date, companyId: any = null, personId: any = null) {
        if (!CommonFunctions.hasValue(this.insertDt)) {
            this.insertDt = date;
            this.insertUserId = userId;
        }
        this.updateDt = date;
        this.updateUserId = userId;
    }
    setFromForm(data: OrderReceiveDetailsBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();
        if (this.hasId) {
            this.updateDt = dateNow;
            this.insertDt = data.insertDt;
            this.insertUserId = data.insertUserId;
        }
        else {
            this.insertDt = dateNow;
            this.insertUserId = data.insertUserId;
        }

    }

     orderReceiveDetailId: any;
     orderDetailId: any;
     orderReceiveId: any;
     inventoryLocationId: any;
     quantityReceived: number ;
     insertUserId: any;
     insertDt: Date ;
     updateUserId: any;
     updateDt: Date ;
     isXfered: boolean;
     inventoryId: any;
     supplierId: any;
     currentCost: number;
     updateCost: boolean;
}
